<router-outlet (activate)="onActivate($event)">
</router-outlet>

<div class="spinner d-flex align-items-center justify-content-center" *ngIf="loaderService.isPageLoading$.value">
  <div class="overlay-bg"></div>
</div>